import { Component, Input, OnInit } from '@angular/core';
import { Idea } from '@models/Sessions/Idea/Idea';
import { Participant } from '@models/Sessions/Participant';
import { Session } from '@models/Sessions/Session';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BusService } from '@services/bus.service';
import { EventsService } from '@services/events.service';
import { PdfReportService } from '@services/sessions/pdfreport.service';
import { SessionsRequestService } from '@services/sessions/sessions.request.service';
import * as FileSaver from 'file-saver';
import _ from 'lodash';

@Component({
  selector: 'app-sessions-export-wizard-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ExportWizardModalComponent implements OnInit {
  modal = {
    step: 1,
  };
  exportVotes = false;
  exportComments = false;

  @Input() session: Session;
  sessionExportData: Session;

  get ideas(): (Idea & { selected?: boolean })[] {
    return this.sessionExportData.data.ideas;
  }

  get participants(): (Participant & { selected?: boolean })[] {
    return this.sessionExportData.config.participants;
  }

  constructor(
    private activeModal: NgbActiveModal,
    private bus: BusService,
    private events: EventsService,
    private pdfReport: PdfReportService,
    private sessionRequest: SessionsRequestService,
  ) {}

  selectAll(collection) {
    _.forEach(collection, element => {
      element.selected = true;
    });
  }

  deselectAll(collection) {
    _.forEach(collection, element => {
      element.selected = false;
    });
  }

  export() {
    const exportObj = {
      data: {
        ideas: [],
      },
      config: {
        participants: [],
        teams: this.sessionExportData.config.teams,
      },
    };
    _.forEach(this.sessionExportData.data.ideas, (idea: any) => {
      if (idea.selected) {
        delete idea.selected;
        if (!this.exportVotes) {
          idea.votes = [];
        }
        if (!this.exportComments) {
          idea.comments = [];
        }
        exportObj.data.ideas.push(idea);
      }
    });
    _.forEach(
      this.sessionExportData.config.participants,
      (participant: any) => {
        if (participant.selected) {
          delete participant.selected;
          exportObj.config.participants.push(participant);
        }
      },
    );
    const data = new Blob([JSON.stringify(exportObj)], {
      type: 'application/json;charset=utf-8',
    });
    FileSaver.saveAs(data, 'export-' + this.session._id + '.json');
    this.activeModal.close();
  }

  receiveSession(sessionData) {
    this.sessionExportData = sessionData;
  }

  sessionError(error) {
    console.error(error);
  }

  dismiss() {
    this.activeModal.dismiss();
  }

  ngOnInit() {
    this.bus.subscribe(
      this.events.received.data.session.export.success,
      this.receiveSession.bind(this),
    );
    this.bus.subscribe(
      this.events.received.data.session.export.failure,
      this.sessionError.bind(this),
    );
    this.bus.publish(
      this.events.requested.data.session.export,
      this.session._id,
    );
  }
}
